import { createContext, useState, useContext, ReactNode } from "react";

// Define the shape of the context data
interface UserInfoContextProps {
  user: any;
  saveUserInfo: (userData: any) => void;
  updateUserInfo: (key: string, value: any) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
  program: any;
  saveProgramInfo: (programData: any) => void;
  updateProgramInfo: (key: string, value: any) => void;
}

// Default values for the context
const defaultValue: UserInfoContextProps = {
  user: null,
  saveUserInfo: () => {},
  updateUserInfo: () => {},
  logout: () => {},
  isAuthenticated: () => false,
  program: null,
  saveProgramInfo: () => {},
  updateProgramInfo: () => {},
};

const UserInfoContext = createContext<UserInfoContextProps>(defaultValue);

const useUserInfo = () => {
  return useContext(UserInfoContext);
};

interface UserProviderProps {
  children: ReactNode;
}

const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState<any>(null);
  const [program, setProgram] = useState<any>({id: 1});
  
  const saveUserInfo = (userData: any) => {
    setUser(userData);
  };

  const updateUserInfo = (key: string, value: any) => {
    setUser((prevUser:any) => ({
      ...prevUser,
      [key]: value,
    }));
  };

  const saveProgramInfo = (programData: any) => {
    setProgram(programData);
  }

  const updateProgramInfo = (key: string, value: any) => {
    setProgram((prevUser:any) => ({
      ...prevUser,
      [key]: value,
    }));
  };


  const logout = () => {
    //console.log("logout call");
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!user;
  };

  return (
    <UserInfoContext.Provider
      value={{
        user,
        saveUserInfo,
        updateUserInfo,
        logout,
        isAuthenticated,
        program,
        saveProgramInfo,
        updateProgramInfo
      }}
    >
      {children}
    </UserInfoContext.Provider>
  );
};

export { UserInfoContext, UserProvider, useUserInfo };
